// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3qwvY","amount":"Amount_amount__1lpWF","tip":"Amount_tip__2mcZa","tipHeader":"Amount_tipHeader__3XFDO","tipsWrap":"Amount_tipsWrap__rQqW2"};